import React, { useState } from 'react';
import HotelPage from './HotelPage/index'
import { useParams } from "react-router-dom";
import DashboardLayout from './layout/dashboardLayout';
import LoadingOverlay from '../components/loading/loading';

const HotelUpdatePage = (props) => {
    const { id } = useParams();
    const [loading] = useState(false);
    return (
        <DashboardLayout>
            {loading && <LoadingOverlay />}
            <HotelPage hotel_id={id} />
        </DashboardLayout>
    )
};
export default HotelUpdatePage;